import {
	Box,
	Typography
} from "@mui/material";
import useEmotionStyles from "@styles/shared/useEmotionStyles";
import { CompareDataStyle } from "@styles/assignments/CompareDataStyle";

import { useTranslation } from 'react-i18next';


import { TextViewer } from "@components/common";
import { ChangeFlag } from "@repositories/model/support/ChangeFlag";
import { useCurrentParagraphHTML } from "../../../../shared/functions/useCurrentParagraphHtml";
import { useIsParagraphAndSourceBoxEmpty } from "../../../../shared/functions/useIsParagraphAndSourceBoxEmpty";
import { QuestionAndReferenceTabQuestionRow } from "./QuestionAndReferenceTabQuestionRow";
import { IExamInfo } from "@repositories/model/transfer/IExamInfo";

type Props = {
	examInfo: IExamInfo;
	index: number;
	editMode: boolean;
	answerList: any;
	changeAnswer: any;
	isRecognizedAll: boolean;
}

export const QuestionAndReferenceTabExamRow = (props: Props) => {
	const { examInfo, index, editMode, answerList, changeAnswer, isRecognizedAll } = props;
	const i18next = useTranslation();
	const classes = useEmotionStyles(CompareDataStyle);

	// const questionListLen = React.useMemo(() => {
	// 	return examInfo.questions.filter(q => q.changeFlag !== FlagType.DELETED).length;
	// }, [examInfo, examInfo.questions]);

	// const currentParagraphHTML = React.useMemo(() => {
	// 	if (!examInfo.paragraph && !examInfo.source) return "<></>";
	// 	const source = examInfo.source.replace(/\n/g, "<br>");

	// 	return (
	// 		"<p>" +
	// 		"<div style='font-size: 1rem;font-weight: 500;'>" +
	// 		examInfo.paragraph +
	// 		"\n\n" +
	// 		'</div>' +
	// 		"<div style='font-size: 0.875rem; text-align: right'>" +
	// 		source +
	// 		'</div>' +
	// 		"</p>"
	// 	);

	// 	// return "<p>"+"<div style='font-size: 1rem;font-weight: 500;'>" + examInfo.paragraph + "\n\n"+'</div>' + "<div style='font-size: 0.875rem; text-align: right'>" + examInfo.source + '</div>' + "</p>";
	// }, [examInfo.paragraph, examInfo.source]);

	const currentParagraphHTML = useCurrentParagraphHTML({
		examInfo,
		paragraph: { fontSize: "1rem", fontWeight: 500 },
		source: { fontSize: "0.875rem", textAlign: "right" }
	});


	// const isParagraphAndSourceBoxEmpty = React.useMemo(() => {
	// 	const emptyParagraph = !examInfo.paragraph || (DataUtils.getTagArrFromHtml(examInfo.paragraph, 'img').length === 0 && !DataUtils.getTextFromHtml(examInfo.paragraph));
	// 	const emptySource = !examInfo.source;

	// 	return emptyParagraph && emptySource;
	// }, [examInfo.paragraph, examInfo.source]);
	const isParagraphAndSourceBoxEmpty = useIsParagraphAndSourceBoxEmpty(examInfo);

	return (
		<>
			<Typography className={classes.textArticleNumber}>{`${index}${i18next.t('번 문항')}`}</Typography>
			<Box className={classes.compareRound}>
				{examInfo.directive && (
					<Typography className={classes.textArticleTitle}>{examInfo.directive}</Typography>
				)}
				{!isParagraphAndSourceBoxEmpty && (
					<Box display='flex' alignItems='center' justifyContent='left' className={classes.textArticle}>
						<TextViewer
							currentHTML={currentParagraphHTML}
						/>
					</Box>
				)}

				{examInfo.questions.length > 0 &&
					examInfo.questions
						.filter(q => q.changeFlag !== ChangeFlag.DELETED)
						.map(question => {
							return (
								<QuestionAndReferenceTabQuestionRow
									isRecognizedAll={isRecognizedAll}
									key={question.projectExamQuestionNum}
									examInfo={examInfo}
									editMode={editMode}
									answerList={answerList}
									changeAnswer={changeAnswer}
									questionInfo={question}
								/>
							)
						})
				}
			</Box>
		</>
	)
};